module.exports = __webpack_public_path__ + "img/p4.fe685616.png";